import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function Childcare(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M10 4.07A7.005 7.005 0 004.07 10H10V4.07zM11 2a9 9 0 00-7.652 13.74 3.5 3.5 0 105.432 3.984c.71.18 1.454.276 2.22.276a9.02 9.02 0 002.175-.265 3.5 3.5 0 105.46-3.969A8.958 8.958 0 0020 11V9a1 1 0 011-1h.5a1 1 0 100-2H21a3 3 0 00-3 3v1h-6V3a1 1 0 00-1-1zm6.394 15.334a9.027 9.027 0 01-2.344 1.706 1.501 1.501 0 002.9-.54c0-.47-.216-.89-.556-1.166zM4 18.5c0-.483.228-.913.584-1.188a9.029 9.029 0 002.324 1.706A1.501 1.501 0 014 18.5zm7-6.5h6.93a7.001 7.001 0 01-13.86 0H11z",
    clipRule: "evenodd"
  }));
}

export default Childcare;